<kt-portlet>

	<!-- <kt-portlet-header [sticky]="true" [title]="'Machine List'" [class]="'kt-portlet__head--lg'" [viewLoading$]="dataSource.loading$"> -->

	<!-- </kt-portlet-header> -->
	<!-- end::Header -->

	<kt-portlet-body>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div class="kt-form kt-margin-b-30">
			<!-- start::FILTERS -->
			<form #sForm="ngForm" [formGroup]="searchForm" (ngSubmit)="onSubmited()" class="kt-form__filtration">
				<div class="row align-items-center">
					<div class="col-xl-6 col-md-6 col-sm-12">
						<mat-form-field>
							<input matInput placeholder="Event Description" formControlName="logDesc" class="mat-form-field mat-form-field-fluid">
							<!-- <mat-select placeholder="Log Description" formControlName="logDesc" class="mat-form-field mat-form-field-fluid" multiple>
								<mat-option *ngFor="let item of opts" value="{{item.log_code}}">{{item.log_msg}}</mat-option>
							</mat-select> -->

							<mat-hint align="start">
								<strong>Search by Event Description</strong>
							</mat-hint>
						</mat-form-field>
					</div>
				</div>
				<div class="row mt-2">

					<div class="col-xl-4 col-md-6 col-sm-12">
						<mat-form-field>
							<input matInput formControlName="startDate" [matDatepicker]="pickerS" placeholder="Choose a start date" required>
							<mat-datepicker-toggle matSuffix [for]="pickerS"></mat-datepicker-toggle>
							<mat-datepicker #pickerS></mat-datepicker>
							<mat-error *ngIf="!searchForm.get('startDate').valid">Please select start date</mat-error>
						  </mat-form-field>
					</div>

					<!-- <div class="col-xl-1"></div> -->
					<div class="col-xl-4 col-md-6 col-sm-12">
						<mat-form-field>
							<input matInput formControlName="endDate" [matDatepicker]="pickerE" placeholder="Choose an end date" required>
							<mat-datepicker-toggle matSuffix [for]="pickerE"></mat-datepicker-toggle>
							<mat-datepicker #pickerE></mat-datepicker>
							<mat-error *ngIf="!searchForm.get('endDate').valid">Please select end date</mat-error>
						  </mat-form-field>
					</div>

					<!-- <div class="col-md-6 col-sm-4"></div> -->

					<div class="col-xl-4 col-md-6 col-sm-8">
						<button [disabled]="!searchForm.valid" mat-raised-button type="submit" color="primary">
							<mat-icon class="mt-1">search</mat-icon>
							Search
						</button>
					</div>
				</div>
			</form>
			<!-- end::FILTERS -->
		</div>
		<!-- end::FILTERS & GROUP ACTIONS -->

		<div class="mat-table__wrapper">

			<mat-table class="lmat-elevation-z8"
				#table
				[dataSource]="dataSource"
				matSort
				matSortActive="time_stamp"
				matSortDirection="desc"
				matSortDisableClear>

				<ng-container matColumnDef="log_desc">
					<mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
					<mat-cell *matCellDef="let log">
						{{parseLogCodes(log)}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="time_stamp">
					<mat-header-cell mat-sort-header *matHeaderCellDef>Date</mat-header-cell>
					<mat-cell *matCellDef="let log">
						{{log.time_stamp | date:'MM/dd/yy hh:mm:ss a'}}
					</mat-cell>
				</ng-container>



				<!-- <ng-container matColumnDef="actions">
					<mat-header-cell Actions</mat-header-cell>
					<mat-cell *matCellDef="let sale">
						<button (click)="viewMachine(machine.m_id)" mat-icon-button color="primary" matTooltip="View Machine">
							<mat-icon>visibility</mat-icon>
						</button>&nbsp;
					</mat-cell>
				</ng-container> -->

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>
			<div class="mat-table__message" *ngIf="!searchForm.valid">Please apply filters</div>
			<div class="mat-table__message" *ngIf="(!(dataSource.loading$ | async) && dataSource.empty) && searchForm.valid">No records found</div>
			<div class="mat-table__message" *ngIf="dataSource.loading$ | async">Please wait....</div>
		</div>


		<div class="mat-table__bottom">
			<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			<mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
		</div>
	</kt-portlet-body>

</kt-portlet>
